import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PieChartComponent } from './pie-chart.component';
import { ChartModule } from 'angular-highcharts';
import { MaterialModule } from 'src/app/shared/material/material.module';

@NgModule({
  declarations: [PieChartComponent],
  imports: [CommonModule, ChartModule,MaterialModule],
  exports: [PieChartComponent],
})
export class PieChartModule {}
